import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const user = useSelector((state) => state.user.loggedUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate(`/login?referer=${ window.location.href }`, { replace: true });
    }
  }, []);

  return user ? children : null;
}

ProtectedRoute.propTypes = {
  children: PropTypes.element.isRequired,
};
